import { render, staticRenderFns } from "./HuoDongGanenMobile.vue?vue&type=template&id=5ab3d1e0&scoped=true&"
import script from "./HuoDongGanenMobile.vue?vue&type=script&lang=js&"
export * from "./HuoDongGanenMobile.vue?vue&type=script&lang=js&"
import style0 from "./HuoDongGanenMobile.vue?vue&type=style&index=0&id=5ab3d1e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab3d1e0",
  null
  
)

export default component.exports